import React from 'react';
import { Form, Field } from 'react-final-form';
import InputField from '../../Pages/Login/InputField';
import Dropzone from './Dropzone';
import axios from 'axios';
import uri from './constants';
import Swal from 'sweetalert2';


const submit = async (values, token, setSuccess) => {
  if (!values.files) {
    alert('Arquivo não adicionado!');

    return;
  }

  if (!values.operation_type) {
    alert('Selecione uma operação!');

    return;
  }

  var formData = new FormData();

  formData.append('entry-file', values.files[0], 'entry.csv');

  formData.append('operation_type', values.operation_type);

  await axios.post(
    `${uri}/unicef/entry-file/`,
    formData,
    {
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json'
      }
    }
  ).then(() => {
    setSuccess(true);

    Swal.fire({
      title: 'Arquivo enviado com sucesso!',
      timer: 3000,
      type: 'success',
      showConfirmButton: false
    })

  }).catch((error) => {
    alert('Ocorreu um erro ao processar o arquivo!');
  })
}

const FileForm = ({ token, setSuccess }) => (
  <Form
    onSubmit={async(values) => submit(values, token, setSuccess)}
    render={( { handleSubmit, submitting } ) => (
      <div>
        <span>Escolha sua operação de recorrência:</span>

        <div className="mt-3">
          <Field component="input" id="recurrency_opt" type="radio" name="operation_type" value="recurrency" />
          <label className="ml-2" htmlFor="recurrency_opt">Cartão de crédito</label>
          <br />
          <Field component="input" id="bank_slips" type="radio" name="operation_type" value="bank_slips" />
          <label className="ml-2" htmlFor="bank_slips">Boleto bancário</label>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <Field name='files'>
              {props => (
                <div>
                  <Dropzone {...props.input} />
                </div>
              )}
            </Field>
          </div>

          <div className="text-center">
            <button
              type="submit"
              className="btn btn-success mt-4"
              disabled={submitting}
            >
              {submitting ? 'Processando, aguarde...' : 'Enviar'}
            </button>
          </div>

        </form>
      </div>
    )}
  />
);

export default FileForm;



// WEBPACK FOOTER //
// ./src/components/Pages/Unicef/FileForm.js